<script>

  import {
    BCol,
  } from 'bootstrap-vue'

  import ListView from '../partials/ListView.vue'
  import ListSortToggler from '../partials/ListSortToggler.vue'

  export default {
    components: {
      BCol,
      ListView,
      ListSortToggler,
    }
  }
</script>
<template>
  <list-view
    store="packagedescriptorauth"
    add-route="PackageDescriptorAuthCreate"
    edit-route="PackageDescriptorAuthUpdate"
  >
    <template #header>
      <b-col md="10">
        <list-sort-toggler
          store="packagedescriptorauth"
          prop-name="name"
        >
          {{ $t('packagedescriptorauth.name.label') }}
        </list-sort-toggler>
      </b-col>
    </template>
    <template #item="slotProps">
      <b-col md="10">
        <div class="p-2">
          {{ slotProps.item.name }}
        </div>
      </b-col>
    </template>
  </list-view>
</template>

